module.exports = __webpack_public_path__ + "static/media/knocki-img.ef192dd1.png";